if (!window.Eurus.loadedScript.has('popup.js')) {
  window.Eurus.loadedScript.add('popup.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.data('xPopups', (data) => ({
        enable: false,
        showMinimal: false,
        show: Shopify.designMode ? ( localStorage.getItem(data.name + '-' + data.sectionId)? xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)) : true ) : false,
        delayDays: data.delayDays ? data.delayDays : 0,
        t: '',
        scheduleTimeout: null,
        intentLoaded: false,
        priorityClosing: false,
        copySuccess: false,
        init() {
          if (Shopify.designMode) {
            var _this = this;
            const handlePopupSelect = (event, isResize = null) => {
              if (event.detail && event.detail.sectionId.includes(data.sectionId) || isResize) {
                if (window.Alpine) {
                  _this.open();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.open();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(true));
                  });
                }
              } else {
                if (window.Alpine) {
                  _this.closeSection();
                  localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                } else {
                  document.addEventListener('alpine:initialized', () => {
                    _this.closeSection();
                    localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
                  });
                }
              }
            }

            document.addEventListener('shopify:section:select', (event) => {
              handlePopupSelect(event);
            });
  
            document.addEventListener('shopify:block:select', (event) => {
              handlePopupSelect(event);
            });

            // Reload the popup and display the overlay when change screen in Shopify admin
            if (data.name != 'popup-age-verification') {
              window.addEventListener('resize', (event)=> {
                handlePopupSelect(event, xParseJSON(localStorage.getItem(data.name + '-' + data.sectionId)));
              })
            }
          }

          if (localStorage.getItem('promotion-popup') == null) {
            localStorage.setItem('promotion-popup', '[]');
          }

          if (this.isPromotionPopup()) {
            document.addEventListener('promotion-popup-priority-change', (event) => {
              if (event.detail && event.detail.sectionId == data.sectionId) return;
              if (this.isBlockedByPriorityPopup()) {
                this.closeForPriorityPopup();
              }
            });
          }
  
          if (this.$el.querySelector('.newsletter-message')) {
            this.open();
            return;
          }

          this.$watch('show', (value) => {
            if (!value) {
              if (this.priorityClosing) {
                this.priorityClosing = false;
                return;
              }
              this.close();
            }
          });
        },
        load(sectionId) {
          // Optimize the JavaScript for popup loading.
          if (window.location.pathname === '/challenge') return;

          const _this= this;
          if (Shopify.designMode) {
            _this.open();
          } else {
            if (this.isPromotionPopup() && !this.handleSchedule()) return;

            if (this.isPromotionPopup() && document.querySelector(`#x-age-popup-${sectionId}`) && xParseJSON(localStorage.getItem('popup-age-verification')) == null) {
              document.addEventListener("close-age-verification", () => {
                this.runTriggerIntent();
                if (data.trigger_intent == 'delay') {
                  setTimeout(() => {
                    _this.open();
                  }, data.delays * 1000);
                }
              })
              return;
            }
            
            this.runTriggerIntent();
          }
        },
        open() {
          if (!Shopify.designMode && this.isPromotionPopup() && !this.handleSchedule()) return;
          if (!Shopify.designMode && this.isExpireSave() && !this.show) return;

          var _this = this;
          if (data.name == 'popup-age-verification') {
            if (this.isExpireSave() && !Shopify.designMode && !data.show_popup) return;

            requestAnimationFrame(() => {
              document.body.classList.add("overflow-hidden");
              Alpine.store('xPopup').open = true;
            });
          }

          // Show minimal popup when
          // 1. "Show minimal" is enabled for desktop, default style is set to "minimal", and the window width is >= 768
          // 2. "Show minimal" is enabled for mobile, default mobile style is set to "minimal", and the window width is < 768
          if ((data.showMinimal && data.default_style == "minimal" && window.innerWidth >= 768) 
            || (data.showMinimalMobile && data.default_style_mobile == "minimal" && window.innerWidth < 768)) {
            _this.showMinimal = true;
            _this.show = false;
            if (Shopify.designMode) {
              localStorage.setItem(data.name + '-' + data.sectionId, JSON.stringify(false));
              _this.removeOverlay();
            }
          } else {
            // Show full popup
            if (data.showOnMobile && window.innerWidth < 768 || window.innerWidth >= 768) {
              // Show a full popup the first time a customer accesses the site. If the customer closes the full popup, display a minimal popup for the rest of the session.
              if (localStorage.getItem('current-' + data.sectionId) == 'minimal') {
                _this.showMinimal = true;
                _this.show = false;
                _this.removeOverlay();
              } else {
                _this.show = true;
                _this.showMinimal = false;
                _this.setOverlay();
                if (!Shopify.designMode) {
                  _this.saveDisplayedPopup();
                }
              }
            } else {
              // Show nothing when screen width is < 768 and "Show popup on mobile" is disabled.
              _this.removeOverlay();
            }
          }
        },
        close() {
          if (data.name == 'popup-age-verification') {
            this.show = false;
            requestAnimationFrame(() => {
              document.body.classList.remove("overflow-hidden");
              Alpine.store('xPopup').close();
            });
            document.dispatchEvent(new Event('close-age-verification'));
            if (!this.isExpireSave()) {
              this.setExpire()
            }
            this.removeDisplayedPopup();
            return;
          }
          var _this = this;
          if (Shopify.designMode) {
            requestAnimationFrame(() => {
              setTimeout(() => {
                _this.showMinimal = true;
              }, 300);
            });
          } else {
            this.removeDisplayedPopup();
            if ((data.showMinimal && window.innerWidth >= 768) || (data.showMinimalMobile && window.innerWidth < 768)) {
              requestAnimationFrame(() => {
                setTimeout(() => {
                  _this.showMinimal = true;
                }, 300);
                // Save data to storage when the full popup is closed (the full popup only shows on the first access to the site)
                localStorage.setItem('current-' + data.sectionId, 'minimal');
              });
            } else {
              if (!this.isExpireSave()) {
                this.setExpire()
              }
            }
          }
          requestAnimationFrame(() => {
            setTimeout(() => {
              _this.show = false;
              _this.removeOverlay();
            }, 300);
          });
        },
        triggerIntent() {     
          var _this = this;
          switch (data.trigger_intent) {
            case "exit":
              document.addEventListener('mouseleave', (event) => {
                if (event.clientY <= 0 || event.clientX <= 0 || event.clientY >= window.innerHeight || event.clientX >= window.innerWidth) {
                  _this.open();
                }
              });
              break;
            case "copy_to_clipboard":
              document.addEventListener('copy', () => {
                _this.open();
              });
              break;
            case "scroll":
              window.addEventListener('scroll', () => {
                const scrollPosition = window.scrollY + window.innerHeight;
                const documentHeight = document.documentElement.scrollHeight;
                if (scrollPosition >= documentHeight * data.scroll_height) { // Enable when scroll to scroll_height percent page
                  _this.open();
                }
              });
              break;
            default:
              setTimeout(() => {
                _this.open();
              }, data.delays * 1000);
          }
        },
        runTriggerIntent() {
          if (this.intentLoaded) return;
          this.intentLoaded = true;
          this.triggerIntent();
        },
        closeSection() {
          this.show = false;
          this.showMinimal = false;
          this.removeOverlay();
        },
        setExpire() {
          const item = {
            section: data.sectionId,
            expires: Date.now() + this.delayDays * 24 * 60 * 60 * 1000
          }
          
          localStorage.setItem(data.sectionId, JSON.stringify(item))
          // Remove storage data so that the full popup will be displayed again when the reappear rule is applied on the site.
          localStorage.removeItem('current-' + data.sectionId);
          setTimeout(()=>{
            if (!this.handleSchedule()) return;
            this.saveDisplayedPopup();
            this.show = true;
          }, item.expires - Date.now())
        },

        isExpireSave() {
          const item = xParseJSON(localStorage.getItem(data.sectionId));
          if (item == null) return false;

          if (Date.now() > item.expires) {
            localStorage.removeItem(data.sectionId);
            return false;
          }

          return true;
        },
        handleSchedule() {
          if (this.isPriorityPromotionPopup()) {
            const schedule = this.getRecurringScheduleState();
            this.setRecurringScheduleTimer(schedule);
            this.setPriorityPromotionPopupActive(schedule.canShow);
            if (!schedule.canShow) {
              if (!Shopify.designMode) {
                requestAnimationFrame(() => {
                  this.closeForPriorityPopup();
                });

                return false;
              }
            }
          } else if (this.isBlockedByPriorityPopup()) {
            this.closeForPriorityPopup();
            return false;
          }

          if (data.showCountdown) {
            let el = document.getElementById('x-promotion-' + data.sectionId);
            let settings = xParseJSON(el.getAttribute('x-countdown-data'));
            if (!Alpine.store('xHelper').canShow(settings)) {
              if (!Shopify.designMode && data.schedule_enabled) {
                requestAnimationFrame(() => {
                  this.show = false;
                });

                return false;
              }
            }
          }

          this.enable = true;
          return true;
        },
        isPromotionPopup() {
          return data.name == 'popup-promotion' || data.name == 'popup-promotion-custom';
        },
        isPriorityPromotionPopup() {
          return data.name == 'popup-promotion-custom' && data.recurring_schedule_enabled;
        },
        getPriorityPromotionPopups() {
          window.Eurus.priorityPromotionPopups = window.Eurus.priorityPromotionPopups || {};
          return window.Eurus.priorityPromotionPopups;
        },
        setPriorityPromotionPopupActive(active) {
          const priorityPopups = this.getPriorityPromotionPopups();
          if (active) {
            priorityPopups[data.sectionId] = true;
          } else {
            delete priorityPopups[data.sectionId];
          }

          document.dispatchEvent(new CustomEvent('promotion-popup-priority-change', {
            detail: {
              sectionId: data.sectionId,
              active,
              hasActive: Object.keys(priorityPopups).length > 0
            }
          }));
        },
        isBlockedByPriorityPopup() {
          if (!this.isPromotionPopup() || this.isPriorityPromotionPopup()) return false;

          return Object.keys(this.getPriorityPromotionPopups()).length > 0;
        },
        closeForPriorityPopup() {
          if (this.show) {
            this.priorityClosing = true;
          }
          this.show = false;
          this.showMinimal = false;
          this.removeDisplayedPopup();
          this.removeOverlay();
        },
        getRecurringScheduleState() {
          const minute = 60 * 1000;
          const hour = 60 * minute;
          const day = 24 * hour;
          const week = 7 * day;
          const now = this.getRecurringScheduleNow(hour);
          const nowInWeek = now.day * day
            + now.hour * hour
            + now.minute * minute
            + now.second * 1000
            + now.millisecond;
          const start = Number(data.recurring_start_day || 0) * day
            + Number(data.recurring_start_hour || 0) * hour
            + Number(data.recurring_start_minute || 0) * minute;
          const end = Number(data.recurring_end_day || 0) * day
            + Number(data.recurring_end_hour || 0) * hour
            + Number(data.recurring_end_minute || 0) * minute;
          const fullWeek = start == end;
          const canShow = fullWeek || (start < end
            ? nowInWeek >= start && nowInWeek < end
            : nowInWeek >= start || nowInWeek < end);
          let msUntilChange = week;

          if (!fullWeek) {
            if (canShow) {
              msUntilChange = end > nowInWeek ? end - nowInWeek : week - nowInWeek + end;
            } else {
              msUntilChange = start > nowInWeek ? start - nowInWeek : week - nowInWeek + start;
            }
          }

          return {
            canShow,
            msUntilChange
          };
        },
        getRecurringScheduleNow(hour) {
          const timezone = String(data.recurring_timezone || '').trim();

          if (timezone && Number.isNaN(Number(timezone))) {
            try {
              const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                weekday: 'short',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hourCycle: 'h23'
              }).formatToParts(new Date());
              const part = (type) => parts.find((item) => item.type == type)?.value;
              const days = {
                Sun: 0,
                Mon: 1,
                Tue: 2,
                Wed: 3,
                Thu: 4,
                Fri: 5,
                Sat: 6
              };

              return {
                day: days[part('weekday')],
                hour: Number(part('hour')),
                minute: Number(part('minute')),
                second: Number(part('second')),
                millisecond: Date.now() % 1000
              };
            } catch (error) {
              // Fall back to UTC when the browser cannot parse the time zone.
            }
          }

          const fixedTimezone = Number(timezone || 0);
          const now = new Date(Date.now() + (Number.isNaN(fixedTimezone) ? 0 : fixedTimezone) * hour);

          return {
            day: now.getUTCDay(),
            hour: now.getUTCHours(),
            minute: now.getUTCMinutes(),
            second: now.getUTCSeconds(),
            millisecond: now.getUTCMilliseconds()
          };
        },
        setRecurringScheduleTimer(schedule) {
          clearTimeout(this.scheduleTimeout);
          this.scheduleTimeout = setTimeout(() => {
            if (this.handleSchedule()) {
              const intentWasLoaded = this.intentLoaded;
              this.runTriggerIntent();
              if (data.trigger_intent == 'delay' && intentWasLoaded) {
                setTimeout(() => {
                  this.open();
                }, data.delays * 1000);
              }
            }
          }, Math.max(schedule.msUntilChange, 1000));
        },
        clickMinimal() {
          if (!Shopify.designMode && this.isPromotionPopup() && !this.handleSchedule()) return;

          requestAnimationFrame(() => {
            this.show = true;
            this.showMinimal = false;
            if (!Shopify.designMode) {
              this.saveDisplayedPopup()
            }
            this.setOverlay();
          })
        },
        setOverlay() {
          let popupsDiv = document.querySelector("#eurus-popup");
          if (popupsDiv.classList.contains('bg-[#acacac]')) return
          if (data.overlay) {
            popupsDiv.className += ' bg-[#acacac] bg-opacity-30';
          }
        },
        removeOverlay() {
          let popupsDiv = document.querySelector("#eurus-popup")
            displayedPopups = xParseJSON(localStorage.getItem("promotion-popup")) || [];
          if (popupsDiv.classList.contains('bg-[#acacac]') && displayedPopups.length == 0) {
            popupsDiv.classList.remove('bg-[#acacac]', 'bg-opacity-30');
          }
        },
        // Closing the minimal popup will set it as expired.
        closeMinimal() {
          this.showMinimal = false;
          if (Shopify.designMode) return

          if (!this.isExpireSave()) this.setExpire();
        },
        saveDisplayedPopup() {
          let localStorageArray = xParseJSON(localStorage.getItem('promotion-popup')) || [];
          if (!localStorageArray.some(item => item == data.name + '-' + data.sectionId)) {
            localStorageArray.push(data.name + '-' + data.sectionId);
            localStorage.setItem('promotion-popup', JSON.stringify(localStorageArray));
          }
        },
        removeDisplayedPopup() {
          let localStorageArray = xParseJSON(localStorage.getItem('promotion-popup')) || [],
            updatedArray = localStorageArray.filter(item => item != data.name + '-' + data.sectionId);
          localStorage.setItem('promotion-popup', JSON.stringify(updatedArray));
        },
      }))
    })
  })
}
